export function useCategorySeoUrl() {
    const seoMapState = useState<Record<string, string>>('categorySeoMap', () => ({}));
    const seoMapCountState = useState<number>('categorySeoMapCount', () => 0);

    function getUrlById(categoryId?: string | null): string | null {
        if (!categoryId) return null;
        const url = seoMapState.value[categoryId];
        return url || null;
    }

    return { getUrlById, seoMap: seoMapState, seoMapCount: seoMapCountState };
}
